import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import { calcSensorHex } from '@helpers/helper';

import type { IActionItem } from '@model/actionItem';

import style from './style.module.scss';

interface IProps {
  item?: IActionItem;
  length: number;
  label: string;
}

const ActiveActionItems: React.FC<IProps> = ({ item, length, label }) => {
  const { customerId } = useParams();
  const { pathname } = useLocation();

  if (!item) return null;

  const { id, title, installation_point } = item;

  return (
    <div className={style.boldText}>
      {label}:{' '}
      {length === 1 ? (
        <Link
          className={style.openAiLink}
          to={`/customer/${customerId}/ai/${id}`}
          state={{ prevPage: pathname }}
          target="_blank"
        >
          {title} - {calcSensorHex(installation_point.sensor?.hardware_id, installation_point.sensor_id)}
        </Link>
      ) : (
        <>
          (<span className={style.openAiLink}>{length}</span>)
        </>
      )}
    </div>
  );
};

export default ActiveActionItems;
